// src/views/Invite.tsx
import React, { useState } from "react";
import {
    Box,
    Typography,
    Button,
    Card,
    CardContent,
    LinearProgress,
    IconButton,
    Snackbar,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ShareIcon from "@mui/icons-material/Share";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import GiftIcon from "@mui/icons-material/CardGiftcard";
import { useNavigate } from "react-router-dom";

const Invite: React.FC = () => {
    const navigate = useNavigate();
    const [progress, setProgress] = useState({ invited: 2, target: 5 });
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const referralLink = "https://ngwallet.app/invite?ref=YOURCODE123";

    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: "Join NG Credit",
                    text: "Sign up with NG Credit and start building your credit score. Use my link!",
                    url: referralLink,
                });
            } catch (err) {
                console.error("Share failed:", err);
            }
        } else {
            navigator.clipboard.writeText(referralLink);
            setSnackbarOpen(true);
        }
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(referralLink);
        setSnackbarOpen(true);
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: "background.default",
                color: "text.primary",
                p: 2,
            }}
        >
            {/* Back Button */}
            <IconButton onClick={() => navigate("/rewards")} size="small" sx={{ mb: 2 }}>
                <ArrowBackIcon />
            </IconButton>

            {/* Headline Section */}
            <Card
                sx={{
                    borderRadius: 3,
                    boxShadow: 3,
                    textAlign: "center",
                    mb: 3,
                    p: 2,
                }}
            >
                <CardContent>
                    <GiftIcon sx={{ fontSize: 50, color: "primary.main", mb: 1 }} />
                    <Typography variant="h5" fontWeight="bold" gutterBottom>
                        Invite Friends & Earn ₦8,000
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Earn up to ₦1,000,000 in referral bonuses by inviting friends to
                        NG Credit.
                    </Typography>
                </CardContent>
            </Card>

            {/* Progress Tracker */}
            <Card
                sx={{
                    borderRadius: 3,
                    boxShadow: 2,
                    mb: 3,
                    p: 2,
                }}
            >
                <CardContent>
                    <Typography variant="subtitle1" gutterBottom>
                        Progress
                    </Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        You’ve invited {progress.invited} friends. Invite{" "}
                        {progress.target - progress.invited} more to get your bonus!
                    </Typography>
                    <LinearProgress
                        variant="determinate"
                        value={(progress.invited / progress.target) * 100}
                        sx={{
                            height: 10,
                            borderRadius: 5,
                            mb: 1,
                        }}
                    />
                    <Typography variant="caption" color="text.secondary">
                        {progress.invited}/{progress.target} friends invited
                    </Typography>
                </CardContent>
            </Card>

            {/* Share Section */}
            <Box textAlign="center">
                <Button
                    variant="contained"
                    startIcon={<ShareIcon />}
                    onClick={handleShare}
                    sx={{
                        borderRadius: 2,
                        mb: 1.5,
                        px: 3,
                    }}
                    fullWidth
                >
                    Share My Link
                </Button>
                <Button
                    variant="outlined"
                    startIcon={<ContentCopyIcon />}
                    onClick={handleCopy}
                    sx={{
                        borderRadius: 2,
                        px: 3,
                    }}
                    fullWidth
                >
                    Copy Link
                </Button>
            </Box>

            {/* Snackbar */}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}
                message="Referral link copied!"
            />
        </Box>
    );
};

export default Invite;
